module.exports = __webpack_public_path__ + "img/2-1.8dd3a022.png";